export default __webpack_public_path__ + "static/media/blog3.763aa3ee.jpg";